<template>
    <vx-card class="toggle-container" title="My Teams" v-if="teams !== null">
      <vs-popup title="Create New Team" :active.sync="create_team_popup">
          <p>Please use this form to create a new team.</p>
          <vs-input
            v-validate="'required|min:2'"
            data-vv-validate-on="blur"
            label-placeholder="Team Name"
            name="team_name"
            placeholder="Team Name"
            v-model="team_name"
            class="w-full" />
          <span class="text-danger text-sm">{{ errors.first("team_name") }}</span>
          <vs-divider color="primary"></vs-divider>

          <vs-button @click="new_team_submit" color="success" type="filled" class="mr-2">Submit</vs-button>
          <vs-button @click="create_team_popup=false" color="primary" type="border">Cancel</vs-button>
        </vs-popup>

      <div id="filtersContainer">
        <vs-row vs-type="flex" vs-justify="left">
          
          <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12" vs-lg="12" vs-md="12" vs-sm="12">
            <vs-button size="small" class="mt-5 mr-1" @click="createTeam" color="primary" type="filled">Create New Team</vs-button>
          </vs-col>
        </vs-row>
      </div>

      <vs-table stripe :max-items="per_page" pagination :data="teams" class="mt-5">
      <template slot="thead">
        <vs-th>
          Team Name
        </vs-th>
        <vs-th>
          Toggles
        </vs-th>
        <vs-th>
          
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="teams[indextr].name">
            {{teams[indextr].name}}
          </vs-td>

          <vs-td :data="teams[indextr].toggles">
            {{teams[indextr].toggles}}
          </vs-td>

          <vs-td :data="teams[indextr].team_id">
            <router-link :to="`/teams/${teams[indextr].team_id}`">View Team</router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    </vx-card>
</template> 

<script>
import axios from 'axios'
import authHeader from '@/services/auth-header'

export default {
  name: 'MyTeams',
  data () {
    return {
      current_page: 1,
      total: 100,
      create_team_popup: false,
      per_page: 15,
      teams: null,
      team_name: null,
      search_price: '',
      search_city: '',
      search_address: ''
    }
  },
  computed: {
    active_user () { 
      return this.$store.state.active_user
    }
  },
  mounted () {
    this.get_teams()
  },
  /*watch: {
    current_page: function (newVal, oldVal) {
      this.get_toggles()
    },
    per_page: function (newVal, oldVal) {
      this.get_toggles()
    }
  },*/
  methods: {
    createTeam () {
      this.create_team_popup = true
    },
    set_per_page (val) {
      this.per_page = val
    },
    doSearch () {
      this.get_teams()
    },
    new_team_submit () {
      const team = {
        team_name: this.team_name
      }
      axios.post(`${process.env.VUE_APP_API_HOST}teams/submit`, team, authHeader()).then(response => {
        this.loading = false
        if (response.data.code === '200') {
          this.create_team_popup = false
          return true
        }
      })
        .catch(error => {
          this.loading = false
          this.$vs.notify({
            'time':10000,
            'title':'Error',
            'text':error.message,
            'color':'danger'
          })
          return false
        })
    },
    get_teams () {
      axios.get(`${process.env.VUE_APP_API_HOST}teams/my`, authHeader()).then(response => {
        if (response.data.teams) {
          this.total = Object.keys(response.data.teams).length
          this.teams = response.data.teams
        }
      })
        .catch(error => {
          this.$vs.notify({
            'time':10000,
            'title':'Error',
            'text':error.message,
            'color':'danger'
          })
          return false
        })
    }
  }
}
</script>
